(function() {
  function applyApplePayShortLabel(root) {
    const btn = root.querySelector('.product-form .shopify-payment-button__button--apple-pay .shopify-cleanslate div[role="button"]');
    if (!btn) return;
    // Nuke inner fallback content so our CSS ::after shows " Pay"
    Array.from(btn.children).forEach(el => { el.style.display = 'none'; });
    // Also try to force native short style when available
    try {
      btn.style.webkitAppearance = '-apple-pay-button';
      btn.style.applePayButtonType = 'plain';
      btn.style.applePayButtonStyle = 'black';
      btn.textContent = ''; // ensure no leftover text
    } catch (e) {}
  }

  function init() {
    applyApplePayShortLabel(document);

    // Re-apply when Shopify re-renders the payment buttons
    const obs = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(n => {
            if (!(n instanceof HTMLElement)) return;
            if (n.matches && n.matches('.shopify-payment-button, .product-form, [data-shopify="payment-button"]')) {
              applyApplePayShortLabel(document);
            } else if (n.querySelector) {
              const pb = n.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
              if (pb) applyApplePayShortLabel(document);
            }
          });
        }
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();